var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-default',[_c('pa-finalization-page',{attrs:{"quote-id":_vm.quoteId,"channel":"agent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }